export function OpentronsToughPCRAutoSealingLid(): JSX.Element {
  return (
    <svg id="TcDisposable" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <g id="BgFill">
        <path
          stroke="#4a4a4a"
          fill="#f09d20"
          opacity={0.4}
          strokeWidth=".5px"
          strokeMiterlimit={10}
          d="M124.749 0.175293C126.448 0.175293 127.83 1.5462 127.83 3.23178V81.768C127.83 83.4532 126.448 84.8245 124.749 84.8245H3.26457C1.56584 84.8245 0.183594 83.4536 0.183594 81.768V3.23178C0.183594 1.5462 1.56549 0.175293 3.26457 0.175293H124.749Z"
        />
      </g>
      <g id="CornerBrackets">
        <path
          id="TopLeftBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M124.75 0.350796C126.352 0.350796 127.655 1.64313 127.655 3.23188V81.7681C127.655 83.3565 126.352 84.6492 124.75 84.6492H3.26559C1.66446 84.6492 0.361419 83.3569 0.361419 81.7681V3.23188C0.361419 1.64313 1.66411 0.350796 3.26559 0.350796H124.75ZM124.75 0H3.26559C1.46644 0 0.0078125 1.44703 0.0078125 3.23188V81.7681C0.0078125 83.553 1.46644 84.9997 3.26559 84.9997H124.75C126.55 84.9997 128.008 83.5526 128.008 81.7678V3.23188C128.008 1.44703 126.55 0 124.75 0Z"
        />
        <path
          id="BottomRightBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M0.183594 4.16748H2.51174C2.51174 4.16748 3.2925 4.82522 3.2925 5.78114V30.4421C3.2925 31.398 2.51174 32.0558 2.51174 32.0558H0.183594"
        />
        <path
          id="BottomLeftBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M0.183594 80.8336H2.51174C2.51174 80.8336 3.2925 80.1759 3.2925 79.2199V54.559C3.2925 53.6031 2.51174 52.9453 2.51174 52.9453H0.183594"
        />
        <path
          id="LeftTopBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M127.828 4.16748H125.5C125.5 4.16748 124.719 4.82522 124.719 5.78114V30.4421C124.719 31.398 125.5 32.0558 125.5 32.0558H127.828"
        />
        <path
          id="LeftBottomBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M127.828 80.8336H125.5C125.5 80.8336 124.719 80.1759 124.719 79.2199V54.559C124.719 53.6031 125.5 52.9453 125.5 52.9453H127.828"
        />
        <path
          id="LeftTopBracket-2"
          data-name="LeftTopBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M34.2472 0.175293V2.19798C34.2472 2.19798 33.5842 2.97254 32.6206 2.97254H6.29456C5.33098 2.97254 4.66797 2.19798 4.66797 2.19798V0.175293"
        />
        <path
          id="LeftBottomBracket-2"
          data-name="LeftBottomBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M93.7617 0.175293V2.19798C93.7617 2.19798 94.4247 2.97254 95.3883 2.97254H121.714C122.678 2.97254 123.341 2.19798 123.341 2.19798V0.175293"
        />
        <path
          id="TopLeftBracket-2"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M34.2472 84.8246V82.8019C34.2472 82.8019 33.5842 82.0273 32.6206 82.0273H6.29456C5.33098 82.0273 4.66797 82.8019 4.66797 82.8019V84.8246"
        />
        <path
          id="TopRightBracket"
          stroke="#4a4a4a"
          fill="none"
          strokeWidth=".4px"
          strokeMiterlimit={10}
          d="M93.7617 84.8246V82.8019C93.7617 82.8019 94.4247 82.0273 95.3883 82.0273H121.714C122.678 82.0273 123.341 82.8019 123.341 82.8019V84.8246"
        />
      </g>
    </svg>
  )
}
